import React from "react";
import {
  LibraryMusic,
  EventAvailableRounded,
  RoomOutlined,
  CardTravel,
  Payment,
  EventSeat,
  GetApp,
  LinkRounded,
  Redeem,
} from "@material-ui/icons";
import ViewSampleVideoPopUp from "../Invitations/assets/resources/ViewSampleVideoPopUp";

const FEATURES = [
  { icon: <EventAvailableRounded />, label: "Calendar links" },
  { icon: <LibraryMusic />,         label: "Play music" },
  { icon: <RoomOutlined />,         label: "Google Maps" },
  { icon: <CardTravel />,           label: "Venue details" },
  { icon: <EventSeat />,            label: "RSVP" },
  { icon: <GetApp />,               label: "Download invitation" },
  { icon: <LinkRounded />,          label: "Custom links" },
  { icon: <Redeem />,               label: "Gift registries" },
  { icon: <Payment />,              label: "Send gifts" },
];

export default function Options() {
  return (
    <section id="options" className="pc-section papercraft pc-section--alt">
      <div className="pc-options-grid">
        <div className="pc-options-copy">
          <span className="pc-eyebrow pc-eyebrow--leading">A details panel, by your side</span>
          <h2 className="pc-section__title">
            Matching envelopes &<br />
            a feature-rich <em style={{ fontStyle: "italic", color: "var(--pc-terracotta)" }}>panel</em>.
          </h2>
          <p className="pc-section__lede">
            Guests are guided to an optional details panel after they open your card —
            quietly handling the logistics so the moment stays beautiful.
          </p>

          <div className="pc-action-wrap" style={{ marginTop: "1.4rem" }}>
            <ViewSampleVideoPopUp />
          </div>

          <ul className="pc-feature-list">
            {FEATURES.map((f) => (
              <li key={f.label}>
                {f.icon}
                <span>{f.label}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="pc-frame">
          <img src={require("./Logos/E-Vite.jpg")} alt="Sample invitation details panel" />
        </div>
      </div>
    </section>
  );
}
